export interface IGridActionIcons {
  name: string;
  iconName: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string | undefined;
  message?: string;
}
